module.exports = __webpack_public_path__ + "static/media/valeu.d1535a50.svg";